<app-dialog-header (backClick)="onNoClick()" [header]="'Modules.Licenses.Orders.LicensesOrder' | translate"></app-dialog-header>

<div class="dialog-view-wrapper" *ngIf="!orderedSuccessfully">
  <ng-container *ngIf="selectedLicenses.length > 0; then order else noLicenses"></ng-container>

  <ng-template #order>
    <table *ngIf="selectedNewLicenses.length > 0" mat-table [dataSource]="selectedNewLicenses" class="order-overview-table">
  
      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->
    
      <!-- Store Column -->
      <ng-container matColumnDef="store">
        <th mat-header-cell *matHeaderCellDef>{{ 'Modules.Licenses.Orders.Table.StoreNewLicense' | translate }}</th>
        <td mat-cell *matCellDef="let license">
          <div class="license-title">{{ getStoreTitle(license) }}</div>
          <div class="license-sub-title-store">{{ getStoreSubTitle(license) }}</div>
          <div class="license-sub-title-license">{{ 'Modules.Licenses.Orders.Table.Fee' | translate }} : {{ license.currency }} {{ license.reconnectionFee | number: PRICE_FORMAT }}, 
            {{ 'Modules.Licenses.Orders.Table.License' | translate }} : {{ license.currency }} {{ license.basePrice | number: PRICE_FORMAT }}
          </div>
        </td>
      </ng-container>
    
      <!-- Total Column -->
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef class="right-align">{{ 'Modules.Licenses.Orders.Table.Total' | translate }}</th>
        <td mat-cell *matCellDef="let license" class="right-align">{{ license.currency }} {{ getTotalLicensePrice(license) | number: PRICE_FORMAT }} </td>
      </ng-container>

       <!-- Remove Column -->
       <ng-container matColumnDef="remove">
        <th mat-header-cell *matHeaderCellDef class="right-align"></th>
        <td mat-cell *matCellDef="let license" class="right-align"><div (click)="removeLicense(license)"><mat-icon>delete</mat-icon></div></td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumnsNewLicenses"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsNewLicenses;"></tr>
    </table>
  
    <div class="total" *ngIf="selectedNewLicenses.length > 0">
      {{ 'Modules.Licenses.Orders.TotalOrder' | translate }}: <b>{{ getCurrency() }} {{ getTotalOrderPrice() | number: PRICE_FORMAT }}</b>
    </div>

    <table *ngIf="selectedCancelledLicenses.length > 0" mat-table [dataSource]="selectedCancelledLicenses" class="order-overview-table">
  
      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->
    
      <!-- Store Column -->
      <ng-container matColumnDef="store">
        <th mat-header-cell *matHeaderCellDef>{{ 'Modules.Licenses.Orders.Table.StoreCancelledLicense' | translate }}</th>
        <td mat-cell *matCellDef="let license">
          <div class="license-title">{{ getStoreTitle(license) }}</div>
          <div class="license-sub-title-license">{{ getStoreSubTitle(license) }}</div>
        </td>
      </ng-container>
    
      <!-- Remove Column -->
      <ng-container matColumnDef="remove">
        <th mat-header-cell *matHeaderCellDef class="right-align"></th>
        <td mat-cell *matCellDef="let license" class="right-align"><div (click)="removeLicense(license)"><mat-icon>delete</mat-icon></div></td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumnsCancelledLicenses"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsCancelledLicenses;"></tr>
    </table>

    <div class="total"></div>
  
    <ng-container *ngIf="isOrdered; then ordered else sendOrder"></ng-container>
    
    <ng-template #sendOrder>
      <form class="form-container" [formGroup]="orderFormGroup">
        <!-- Token -->
        <app-input type="email" formControlName="orderCopyEmail" [label]="'Modules.Licenses.Orders.EmailCopy.Label' | translate" 
          [info]="'Modules.Licenses.Orders.EmailCopy.Info' | translate">
        </app-input>
      </form>
  
      <div class="action-buttons">
        <button mat-flat-button class="button small-button" (click)="onSendOrderClick()">
          <mat-icon>send</mat-icon>
          <p>{{ 'Modules.Licenses.Orders.Order' | translate }}</p>
        </button>
      </div>
    </ng-template>
  
    <ng-template #ordered>  
      <div class="action-buttons">
        <button mat-flat-button class="button small-button" disabled="true">
          <mat-icon>send</mat-icon>
          <p>{{ 'Modules.Licenses.Orders.Ordering' | translate }}</p>
        </button>
      </div>
    </ng-template>
  
  </ng-template>
  
  <ng-template #noLicenses>
    <div class="panel-no-data">{{ 'Modules.Licenses.Orders.NoOrders.Title' | translate }}</div>
  </ng-template>
</div>

<div class="panel-no-data" *ngIf="orderedSuccessfully">
  {{ 'Modules.Licenses.Orders.OrderSuccess' | translate }}
</div>